import * as Portal from '@radix-ui/react-portal';

import { BodyMarker } from '../types';

export const DebugPanelStep1 = ({
  bodyMarkers,
}: {
  bodyMarkers: BodyMarker[];
}) => {
  return (
    <Portal.Root>
      <div className="fixed bottom-4 left-4 right-4 z-50 flex justify-around">
        <div className="flex gap-2 rounded-lg bg-white p-4">
          {bodyMarkers.map((item) => (
            <div
              key={item.name}
              style={{ color: item.color }}
              className="flex flex-col gap-2"
            >
              {item.markers.map((marker) => (
                <div key={marker.id} className="text-[12px]/[14px]">
                  <strong>{marker.name}</strong>:
                  <br />
                  x: {marker.worldPosition?.x || 'N/A'} <br />
                  y: {marker.worldPosition?.y || 'N/A'} <br />
                  z: {marker.worldPosition?.z || 'N/A'}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Portal.Root>
  );
};
